import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import CompanyFilter from '../components/company_filter';
import FooterProfile from '../components/footer_profile';
import styles from './listings.module.css';
import Navbar from '../components/navbar';
import isLoggedIn from '../utils/isLoggedIn';

const Companies = () => {
  //set initial states, comics, characters and query filters
  const url = `${process.env.REACT_APP_API}`;
  const token = sessionStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [companies, setCompanies] = useState([]);
  const [filters, setFilters] = useState({
    country: '',
    searchStr: '',
    displayCount: 20,
    page: 1,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch()

  //Get all registered companies  to display -------------\\
  useEffect(() => {
    const getCompanies = async () => {
      const { country, searchStr, displayCount, page } = filters;
      // Get listings on page load..
      const response = await axios.get(
        `${url}/admin/companies?country=${country}&searchStr=${searchStr}&displayCount=${displayCount}&page=${page}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      const [count, companies] = response.data;
      setCompanies(companies);
      setCount(count);

      setLoading(false);
    };

    //Check if user is logged in with a valid token
    isLoggedIn(navigate, dispatch, '/companies');
    const timeoutId = setTimeout(() => {
      getCompanies();
    }, 300);

    return () => {
      clearTimeout(timeoutId);
      setLoading(false);
    };
  }, [filters]);

  // Component return .. .. ;
  return isLoading ? (
    // Waiting data loading after async request...
    <>
      <Helmet>
        <title>Badgers SAS: Enrolled companies</title>
        <meta name='page' content='enrolled companies' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    //All companies .. map and render companies table
    <>
      <Helmet>
        <title>Badgers SAS: Enrolled companies</title>
        <meta name='page' content='enrolled companies' />
      </Helmet>
      <Navbar displayMob={true} />
      <div className=''>
        <CompanyFilter
          count={count}
          filters={filters}
          setFilters={setFilters}
          displayMob={true}
        />
        <div className='container'>
          <div>
            <Link className='page-links' to='/'>
              <FontAwesomeIcon icon='home' />{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <span className='link-span'>ENROLLED COMPANIES</span>
          </div>

          <div className='container'>
            <div className='col-12 d-flex justify-content-center my-4'>
              <h4 className='h4'>
                Enrolled Companies <FontAwesomeIcon icon='building' />
              </h4>
              <button
                className={styles.enroll}
                onClick={(evt) => navigate('/companies/enroll')}
                aria-label='Add to Favourites'
              >
                <FontAwesomeIcon name='add to favourites' icon='plus' />
              </button>
            </div>

            <table className='table table-striped table-hover'>
              <thead>
                <tr className={`${styles.headings}`}>
                  <th scope='col'>#</th>
                  <th scope='col'>SIRET</th>
                  <th scope='col'>Corporate Name</th>
                  <th scope='col'>Country</th>
                  <th scope='col'>City</th>
                  <th scope='col'>Post Code</th>
                  <th scope='col'>Address</th>
                  <th scope='col'>Telephone</th>
                  <th scope='col'>Email</th>
                  <th scope='col'>Key Person</th>
                  <th scope='col'>Created at</th>
                  <th scope='col'>Updated at</th>
                </tr>
              </thead>
              <tbody>
                {companies.length > 0 ? (
                  companies.map((company, idx) => {
                    return (
                      <tr
                        key={company.id}
                        className={`${styles.rows}`}
                        onClick={() => navigate(`/company/${company.id}`)}
                      >
                        <th scope='row'>{idx + 1}</th>
                        <td>{company.siret}</td>
                        <td>{company.raisonSociale}</td>
                        <td>{company.pays}</td>
                        <td>{company.ville}</td>
                        <td>{company.postcode}</td>
                        <td>{company.address}</td>
                        <td>{company.contact}</td>
                        <td>{company.email}</td>
                        <td>{company.dg}</td>
                        <td>
                          {new Date(company.createdAt).toLocaleString('en-UK', {
                            dateStyle: 'short',
                            timeStyle: 'short',
                          })}
                        </td>
                        <td>
                          {new Date(company.updatedAt).toLocaleString('en-UK', {
                            dateStyle: 'short',
                            timeStyle: 'short',
                          })}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={12}>No companies to display ...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <FooterProfile />
      </div>
    </>
  );
};

export default Companies;
